module.exports = __webpack_public_path__ + "static/Gotham-Bold-87a579e07a6953b1105c0f71e453a50b.woff2";